module.exports = __webpack_public_path__ + "assets/language-role.1a7947e5.svg";